<template>
  <div class="sm-empty">
    <div class="sm-empty__block">
      <div class="sm-empty__wrapper">
          <h2 class="sm-title">Результат поиска по запросу <span class="sm-empty__term">«{{ q }}»</span></h2>
          <p>
            По вашему запросу ничего не найдено, попробуйте изменить параметры поиска или перейти к популярным запросам или товарам
          </p>
          <button class="sm-empty__button" @click="doStart">Изменить запрос</button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  name: "not-found",
  computed: {
    ...mapGetters("search", ["q"]),
  },
  methods: {
    ...mapActions("search", [
      "setQString",
      "setStart",
      "setAutocompleteMode",
      "setSearchMode",
      "setBodyClasses"
    ]),
    doStart() {
        this.setQString('')
        this.setStart().then(() => {
          this.setAutocompleteMode();
          this.setBodyClasses();
          // set focus
          const input = document.getElementById('search-input-vue');
          input.focus();
        }).catch(err => {
          console.log(err)
        })
    },
  }
}
</script>